export default "__VITE_ASSET__ruQnIdDK__"